import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/app/App';
import { Provider } from 'react-redux';
import store from './store';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import registerServiceWorker from './registerServiceWorker';
import WebFont from 'webfontloader';
import ScrollToTop from './components/scrolltotop/ScrollToTop';
// import "normalize.css";
import './styles/css/reset.css';
import { ParallaxProvider } from 'react-scroll-parallax';
import HttpsRedirect from 'react-https-redirect';

WebFont.load({
  google: {
    families: [
      'Open Sans:100,300,400,400i,500,600,700',
      'Asap:100,300,400,500,600,700',
    ],
  },
});

// if (process.env.NODE_ENV !== "production") {
//   const { reactopt } = require("reactopt");
//   reactopt(React);
// }

ReactDOM.render(
  <HttpsRedirect>
    <Provider store={store}>
      <Router>
        <ParallaxProvider>
          <ScrollToTop>
            {/* <App /> */}
            <Route path="/" component={App} />
          </ScrollToTop>
        </ParallaxProvider>
      </Router>
    </Provider>
  </HttpsRedirect>,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js